import { parse as parseQuery } from 'hub-http/helpers/params';
import env from 'enviro';
import { SignupEmbedderOptions } from 'signup-embedder';
import { getSubDomain } from './urls';
const SAFE_REFERRER_ORIGINS = ['https://mail.google.com', 'https://teams.microsoft.com', 'https://teams.microsoft.us', 'https://gov.teams.microsoft.us', 'https://dod.teams.microsoft.us', 'https://int.teams.microsoft.com', 'https://outlook.office.com', 'https://outlook-sdf.office.com', 'https://outlook.office365.com', 'https://outlook-sdf.office365.com', 'https://outlook.office365.us', 'https://outlook-dod.office365.us', 'https://outlook.live.com', 'https://outlook-sdf.live.com', 'https://devspaces.skype.com', 'https://www.office.com', 'https://www.officeppe.com', 'https://www.microsoft365.com', 'https://copilot.microsoft.com', 'https://substrate-msb-bizchatvnext-service.sdf01.substrate-msb-bingatwork.eastus2-sdf.cosmic-ppe.office.net', 'https://office-home-m365copilotapp.wus2sdf1.office-home-m365copilotapp.westus2-sdf.cosmic-ppe.office.net', 'https://office-home-m365copilotapp.wus2test1.office-home-m365copilotapp.westus2-test.cosmic-int.office.net', 'https://m365copilotapp.svc.cloud.microsoft', 'https://m365copilotapp.svc.cloud.dev.microsoft', 'https://ffc-copilot.officeapps.live.com', 'https://m365.cloud.dev.microsoft', 'https://m365.cloud.dev.microsoft:3001'];
const SAFE_REFERRER_WILDCARD_SUFFIXES = ['.www.office.com', '.www.microsoft365.com', '.cloud.microsoft', '.m365.cloud.microsoft', '.outlook.cloud.microsoft'];
const isAllowlistedReferrer = referrer => {
  try {
    const url = new URL(referrer);
    if (SAFE_REFERRER_ORIGINS.some(origin => url.origin === origin)) {
      return true;
    }
    return SAFE_REFERRER_WILDCARD_SUFFIXES.some(suffix => url.hostname.endsWith(suffix));
  } catch (_unused) {
    return false;
  }
};
const getSafeReferrerForEmbedder = () => {
  const qaVar = env.isQa() ? 'qa' : '';
  const referrer = `https://app.hubspot${qaVar}.com/signup-hubspot`;
  return referrer.toLowerCase();
};
const getSafeReferrerForOAuthBridge = () => {
  const qaVar = env.isQa() ? 'qa' : '';
  const referrer = `https://app.hubspot${qaVar}.com/oauth-bridge`;
  return referrer.toLowerCase();
};
const parseUrl = url => {
  const search = url ? url.split('?')[1] : undefined;
  const query = search ? parseQuery(search) : {};
  return query;
};
const keepOpenerForEmbedder = url => {
  const activeEmbedder = parseUrl(url)[SignupEmbedderOptions.SIGNUP_EMBEDDER_IS_ACTIVE];
  const curReferrer = document.referrer ? document.referrer : '';
  const isSafeReferrer = curReferrer.toLowerCase().includes(getSafeReferrerForEmbedder()) && activeEmbedder || curReferrer.toLowerCase().includes(getSafeReferrerForOAuthBridge());
  return isSafeReferrer;
};
const doNotCheckOpenerTwice = () => {
  const curUrl = window.location.href;
  const betaVar = curUrl.split('/').slice(-1)[0] === 'beta' ? '' : '/beta';
  const qaVar = env.isQa() ? 'qa' : '';
  const subdomain = getSubDomain();
  const safeLoginReferrer = `https://${subdomain}.hubspot${qaVar}.com/login${betaVar}`;
  const docRef = document.referrer.split('?')[0];
  return safeLoginReferrer === docRef;
};
export const checkSafeOpener = ({
  loginRedirectUrl
}) => {
  if (window.opener) {
    try {
      if (window.opener.origin) {
        console.log('safe origin');
      } else {
        throw new Error('Unsafe origin');
      }
    } catch (error) {
      if (isAllowlistedReferrer(document.referrer)) {
        console.log('safe referrer');
        sessionStorage.setItem('hs-safe-opener', '1');
      } else if (keepOpenerForEmbedder(loginRedirectUrl)) {
        console.log('safe embedder');
        sessionStorage.setItem('hs-safe-opener', '1');
      } else if (doNotCheckOpenerTwice()) {
        console.log('already checked');
      } else if (sessionStorage.getItem('hs-safe-opener')) {
        console.log('safe session');
      } else {
        console.log('unsafe');
        window.opener = null;
      }
    }
  } else {
    console.log('safe no opener');
  }
};